export default "__VITE_ASSET__DxXkPZaD__"